var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First-Cashier",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AD03-EMAIL-2-Dark",
    transform: "translate(-24 -222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selected-checkbox-on-dark",
    transform: "translate(24 222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 24H2a2 2 0 01-2-2V2a2 2 0 012-2h20a2 2 0 012 2v20a2 2 0 01-2 2z",
    id: "Stroke-42",
    fill: "#02BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.073 18a.668.668 0 01-.454-.176l-4.41-4.048a.631.631 0 01-.029-.91.673.673 0 01.935-.028l3.953 3.627 8.81-8.284a.675.675 0 01.936.016.631.631 0 01-.016.91l-9.265 8.711a.665.665 0 01-.46.182",
    id: "Fill-44",
    fill: "#FFF"
  }))))));
}

SvgCheckboxSelected.displayName = 'CheckboxSelected';
export default SvgCheckboxSelected;